(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("SmoothScrollTo", [
    "$window",
    "CustomEasings",
    function ($window, CustomEasings) {
      var defaultScrollDurationMs = 500;

      return function (topOr$el, scrollDurationMs) {
        var elTopInViewport;

        if (topOr$el instanceof angular.element().constructor) {
          elTopInViewport = topOr$el.get(0).getBoundingClientRect().top;
        } else if (typeof topOr$el === "number") {
          elTopInViewport = topOr$el - $window.pageYOffset;
        }

        /* eslint-disable no-param-reassign */
        scrollDurationMs = scrollDurationMs || defaultScrollDurationMs;
        /* eslint-enable no-param-reassign */

        var scrollTop = angular.element(window).scrollTop();

        var deferred = $.Deferred();

        CustomEasings.ensureAvailableForAnimate("scrollToErrorEasing", CustomEasings.curves.EASE_IN_OUT_EXPO, {
          base: 3,
          exponent: 9,
        });

        angular.element("html, body").animate(
          {
            scrollTop: elTopInViewport + scrollTop,
          },
          {
            duration: scrollDurationMs,
            easing: "scrollToErrorEasing",
            complete: function () {
              deferred.resolve();
            },
          }
        );

        return deferred.promise();
      };
    },
  ]);
})(window.angular);
